<eda-dialog2 width="80vw" height="80vh" (apply)="close(true)" (close)="close(false)">
      <div content id=alertdialog class="center">
    <h1 i18n="@@dangerQuery">¡Cuidado!</h1>
    <h3 i18n="@@dangerQueryText1">La consulta que estás a punto de realizar es potencialmente pesada y puede tardar mas de lo normal en
      ejecutarse.
    </h3>
    <h3 i18n="@@dangerQueryText2">Puedes añadir filtros o agregaciones para reducir el número de registros</h3>
    <h3 i18n="@@dangerQueryText3">¿Deseas continuar?</h3>
    <button type="submit" pButton (click)="close(true)" icon="fa fa-check" class="p-button-raised p-button-success"
      i18n-label="@@guardarBtn" label="Confirmar">
    </button>

    <button type="button" pButton (click)="close(false)" icon="fa fa-times" class="p-button-raised p-button-danger"
      i18n-label="@@cancelarBtn" label="Cancelar">
    </button>
  </div>
</eda-dialog2>